import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransitionGroup } from 'react-transition-group';
import './Content.css';

let prevID = 0;

class IFrame extends React.Component {
  state = {
    src: this.props.src
  }
  
  componentWillUnmount(){
    const element = document.getElementById(this.props.id);
    element.src ='';
    ReactDOM.unmountComponentAtNode(element);
  }
  render() {
   return <iframe id={this.props.id} className="Content-player" frameBorder="0" src={this.state.src} allowFullScreen="true" title={this.props.title} onLoad={this.props.contentLoaded}/>;
  }
}

class Content extends Component {
  componentDidMount() {

    window.addEventListener('resize',(e) => {
      this.resizeHeight();
    });
    this.resizeHeight();
  }
  resizeHeight(){
    const content = document.querySelector(".Content-player");
    content.style.height = window.innerHeight;
  }
  render() {
    let slideanimation = "slideNext";
    if(prevID > this.props.id){
        slideanimation = "slidePrev";
    }
    prevID = this.props.id;
    return (
      <div className={this.props.isMenu ? "Content scale-down" : "Content"}>
        <CSSTransitionGroup
          transitionName={slideanimation}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}>
          <IFrame key={this.props.id} src={this.props.src} title={this.props.id} contentLoaded={this.props.contentLoaded} id={`Content${this.props.id}`}/>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/Content.js